import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import Swal from "sweetalert2";
import { ApiService } from "../../../service/apiServices";
import { NgxAlertsService } from "@ngx-plus/ngx-alerts";
import { config } from "process";
import { Global } from "../../../global";
import { FileUploadService } from "src/app/service/fileService";

@Component({
  selector: "app-general-configuration",
  templateUrl: "./general-configuration.component.html",
  styleUrls: ["./general-configuration.component.css"],
})
export class GeneralConfigurationComponent implements OnInit {
  configuracao: any = {};
  abaselecionada: any = 1;
  // upload previews / filenames
  logoImpressoSuperiorPreview: string | null = null;
  logoImpressoInferiorPreview: string | null = null;
  logoImpressoSuperiorFileName: string | null = null;
  logoImpressoInferiorFileName: string | null = null;

  constructor(
    public service: ApiService,
    private location: Location,
    private alerts: NgxAlertsService,
    private global: Global,
    private fileUploadService: FileUploadService
  ) {}

  ngOnInit() {
    this.configuracao.relatorio_caminho_logo = "";
    this.configuracao.relatorio_estado = "";
    this.configuracao.relatorio_municipio = "";
    // sensible defaults
    this.configuracao.utilizar_whatsapp_oficial = false;
    this.configuracao.numero_identificacao_meta = "";
    this.obterConfiguracao();
  }

  goBack() {
    this.location.back();
  }

  salvarConfig = () => {
    if (!this.validaPostConfig()) return;
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    if (this.configuracao.id == null)
      this.service
        .Post(`Configuracao`, this.configuracao)
        .then((res) => {
          setTimeout(() => {
            Swal.close();
            Swal.fire({
              icon: "success",
              title: "Sucesso!",
              html: "configuração salva com sucesso!",
            }).then((result) => {
              if (result.isConfirmed) {
                //this.goBack();
              }
            });
          }, 1000);
        })
        .catch((res) => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Erro",
            html: res.error.erros[0].messagem,
          }).then((result) => {
            if (result.isConfirmed) {
            }
          });
        });
    else
      this.service
        .Put(`Configuracao/${this.configuracao.id}`, this.configuracao)
        .then((res) => {
          setTimeout(() => {
            Swal.close();
            Swal.fire({
              icon: "success",
              title: "Sucesso!",
              html: "Configuração atualizada com sucesso!",
            }).then((result) => {
              if (result.isConfirmed) {
                //this.goBack();
              }
            });
          }, 1000);
        })
        .catch((res) => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Erro",
            html: res.error.erros[0].messagem,
          }).then((result) => {
            if (result.isConfirmed) {
            }
          });
        });
  };

  validaPostConfig = () => {
    if (
      (this.configuracao.url_mensagem_whatsapp == null ||
        this.configuracao.url_mensagem_whatsapp == "") &&
      this.abaselecionada == 1
    ) {
      this.alerts.notifyError({
        body: "Favor preencher o link do whatsApp",
        title: "Erro",
      });
      return false;
    }
    if (
      !(
        this.configuracao.relatorio_caminho_logo == "" &&
        this.configuracao.relatorio_estado == "" &&
        this.configuracao.relatorio_municipio == ""
      ) &&
      !(
        this.configuracao.relatorio_caminho_logo != "" &&
        this.configuracao.relatorio_estado != "" &&
        this.configuracao.relatorio_municipio != ""
      )
    ) {
      this.alerts.notifyError({
        body: "Favor preencher todos os campos da configuração do relatório ",
        title: "Erro",
      });
      return false;
    }
    return true;
  };

  obterConfiguracao = () => {
    this.service
      .Get(`Configuracao`)
      .then((res) => {
        if (res != null) this.configuracao = res;
        // ensure new fields exist with sensible defaults
        if (this.configuracao.utilizar_whatsapp_oficial === undefined || this.configuracao.utilizar_whatsapp_oficial === null) {
          this.configuracao.utilizar_whatsapp_oficial = false;
        }
        if (!this.configuracao.numero_identificacao_meta) {
          this.configuracao.numero_identificacao_meta = "";
        }
        // attempt to build previews if backend returned filenames
        try {
          if (this.configuracao.logo_impresso_senha_superior) {
            this.logoImpressoSuperiorFileName = this.configuracao.logo_impresso_senha_superior;
            this.logoImpressoSuperiorPreview = `${this.global.apiUrl}Arquivo/${this.configuracao.logo_impresso_senha_superior}`;
          }
          if (this.configuracao.logo_impresso_senha_inferior) {
            this.logoImpressoInferiorFileName = this.configuracao.logo_impresso_senha_inferior;
            this.logoImpressoInferiorPreview = `${this.global.apiUrl}Arquivo/${this.configuracao.logo_impresso_senha_inferior}`;
          }
        } catch (e) {}        
      })
      .catch((res) => {
        this.alerts.notifyError({
          body: `${res.error.messagem}`,
          title: "Erro",
        });
      });
  };

  abaAtual = (aba) => {
    this.abaselecionada = aba;
  };

  validaCampoRelatorio = () => {
    let result = !(
      !(
        this.configuracao.relatorio_caminho_logo == "" &&
        this.configuracao.relatorio_estado == "" &&
        this.configuracao.relatorio_municipio == ""
      ) &&
      !(
        this.configuracao.relatorio_caminho_logo != "" &&
        this.configuracao.relatorio_estado != "" &&
        this.configuracao.relatorio_municipio != ""
      )
    );
    return result;
  };

  changeStatusestab(status: boolean) {
    return !status;
  }

  onLogoImpressoSuperiorSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    if (this.logoImpressoSuperiorPreview) {
      try { URL.revokeObjectURL(this.logoImpressoSuperiorPreview); } catch(e){}
    }
    this.logoImpressoSuperiorPreview = URL.createObjectURL(file);
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    const path = `Arquivo/Upload`;
    this.fileUploadService.pushFileToStorage(path, file).then(
      (result: any) => {
        Swal.close();
        let fileName: string | null = null;
        if (!result) {
          fileName = file.name;
        } else if (typeof result === 'string') {
          fileName = result;
        } else if (result.fileName) {
          fileName = result.fileName;
        } else if (result.nome) {
          fileName = result.nome;
        } else if (result.nome_arquivo) {
          fileName = result.nome_arquivo;
        } else if (result.error && result.error.text) {
        if (this.configuracao.utilizar_whatsapp_oficial) {
          if (!this.configuracao.numero_identificacao_meta || this.configuracao.numero_identificacao_meta.trim() === "") {
            this.alerts.notifyError({
              body: "Favor preencher o token / número de identificação da API do WhatsApp oficial",
              title: "Erro",
            });
            return false;
          }
        }
          fileName = result.error.text;
        } else {
          fileName = file.name;
        }

        this.logoImpressoSuperiorFileName = fileName;
        this.configuracao.logo_impresso_senha_superior = fileName;
        try {
          this.logoImpressoSuperiorPreview = `${this.global.apiUrl}Arquivo/${fileName}`;
        } catch (e) {}
      },
      (err) => {
        Swal.close();
        if (err.status == 401) {
          return;
        }
      }
    );
    input.value = "";
  }

  onLogoImpressoInferiorSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    if (this.logoImpressoInferiorPreview) {
      try { URL.revokeObjectURL(this.logoImpressoInferiorPreview); } catch(e){}
    }
    this.logoImpressoInferiorPreview = URL.createObjectURL(file);
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    const path = `Arquivo/Upload`;
    this.fileUploadService.pushFileToStorage(path, file).then(
      (result: any) => {
        Swal.close();
        let fileName: string | null = null;
        if (!result) {
          fileName = file.name;
        } else if (typeof result === 'string') {
          fileName = result;
        } else if (result.fileName) {
          fileName = result.fileName;
        } else if (result.nome) {
          fileName = result.nome;
        } else if (result.nome_arquivo) {
          fileName = result.nome_arquivo;
        } else if (result.error && result.error.text) {
          fileName = result.error.text;
        } else {
          fileName = file.name;
        }

        this.logoImpressoInferiorFileName = fileName;
        this.configuracao.logo_impresso_senha_inferior = fileName;
        try {
          this.logoImpressoInferiorPreview = `${this.global.apiUrl}Arquivo/${fileName}`;
        } catch (e) {}
      },
      (err) => {
        Swal.close();
        if (err.status == 401) {
          return;
        }
      }
    );
    input.value = "";
  }

  onPreviewError(type: 'impressoSuperior' | 'impressoInferior') {
    let fileName = null;
    if (type === 'impressoSuperior') {
      fileName = this.logoImpressoSuperiorFileName || this.configuracao.logo_impresso_senha_superior;
    } else {
      fileName = this.logoImpressoInferiorFileName || this.configuracao.logo_impresso_senha_inferior;
    }
    if (!fileName) return;

    const candidates = [
      `${this.global.apiUrl}Arquivo/${fileName}`,
      `${this.global.apiUrl}arquivo/${fileName}`,
      `${this.global.apiUrl}Arquivo/${fileName}`,
      `${this.global.apiUrl}arquivo/${fileName}`,
    ];

    for (const c of candidates) {
      if (type === 'impressoSuperior') {
        if (!this.logoImpressoSuperiorPreview || this.logoImpressoSuperiorPreview.indexOf(c) === -1) {
          this.logoImpressoSuperiorPreview = c;
          break;
        }
      } else {
        if (!this.logoImpressoInferiorPreview || this.logoImpressoInferiorPreview.indexOf(c) === -1) {
          this.logoImpressoInferiorPreview = c;
          break;
        }
      }
    }
  }
}
